import { createApiResource, UnpagedListResource } from '../apiResourceFactory';
import { API } from '../apiService';
import { CallSegmentListItemDTO, CallSegmentQueryParams } from '../apiTypes.shim';

type CallSegmentResource = UnpagedListResource<CallSegmentListItemDTO, CallSegmentQueryParams, { requireParams: true }>;

export const createCallSegmentResource = (): CallSegmentResource => {
  const callSegmentUri = `call-segment`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(API, callSegmentUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey
  };
};
